type StorybookRuntimeGlobal = typeof globalThis & {
  __STORYBOOK_PREVIEW__?: unknown;
  __STORYBOOK_THEME__?: unknown;
};

const isStorybookRuntime = () => {
  const runtime = globalThis as StorybookRuntimeGlobal;

  if (
    typeof runtime.__STORYBOOK_PREVIEW__ !== "undefined" ||
    typeof runtime.__STORYBOOK_THEME__ !== "undefined"
  ) {
    return true;
  }

  if (typeof window === "undefined") {
    return false;
  }

  const { location } = window;
  const pathname =
    typeof location?.pathname === "string" ? location.pathname : "";
  const href = typeof location?.href === "string" ? location.href : "";

  return pathname.includes("iframe.html") || href.includes("/iframe.html");
};

export { isStorybookRuntime };
